import { makeOperator } from './Operator';
import isString from 'transmute/isString';
export default makeOperator({
  name: 'StartsWith',
  values: [{
    name: 'value',
    isValid: isString
  }]
});